import { graphql, useStaticQuery } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useNavigationData = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: navigationDataJson {
        pageLinks {
          text
          to
        }
        solutionLinks {
          text
          to
        }
        pricingLinks {
          text
          to
        }
        legalLinks {
          text
          to
        }
        language {
          german
          english
        }
        thePuzzlersUrl
      }
      de: deNavigationDataJson {
        pageLinks {
          text
          to
        }
        solutionLinks {
          text
          to
        }
        pricingLinks {
          text
          to
        }
        legalLinks {
          text
          to
        }
        language {
          german
          english
        }
        thePuzzlersUrl
      }
    }
  `);

  return data[locale];
};
